import { FirebasePortalData } from '@oy/types';
import { initializeApp } from 'firebase/app';
import { get, getDatabase, goOffline, goOnline, ref } from 'firebase/database';
import { DEFAULT_FIREBASE_DATA } from './constant';

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const getFirebaseDatabase = () => {
  const firebase = initializeApp(config);
  return getDatabase(firebase);
};

export const fetchRootFirebaseData = async () => {
  const database = getFirebaseDatabase();
  const databaseRef = ref(getFirebaseDatabase());

  let result: FirebasePortalData = DEFAULT_FIREBASE_DATA;
  goOnline(database);
  try {
    const snapshot = await get(databaseRef);
    if (snapshot) {
      const data = snapshot.val();
      if (data) {
        result = data;
      }
    }
  } finally {
    goOffline(database);
  }

  return result;
};
